import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isNative } from "@/lib/appConfig";
import { parseDeepLinkPath, isOAuthCallbackPath } from "@/lib/deepLinks";

// Routes incoming deep links (custom scheme / universal links) into React Router.
// No-op on web. Universal (https) links also require server association files.
export default function DeepLinks() {
    const navigate = useNavigate();
    useEffect(() => {
        if (!isNative()) return;
        let remove = () => {};
        (async () => {
            const { App } = await import("@capacitor/app");
            const handle = await App.addListener("appUrlOpen", async ({ url }) => {
                const path = parseDeepLinkPath(url);
                if (!path) return;
                // Vuelta de una autorizacion OAuth: el navegador del sistema sigue abierto
                // encima en iOS (en Android lo cierra singleTask).
                if (isOAuthCallbackPath(path)) {
                    try {
                        const { Browser } = await import("@capacitor/browser");
                        await Browser.close();
                    } catch (_e) {}
                }
                navigate(path);
            });
            remove = () => handle.remove();
        })();
        return () => remove();
    }, [navigate]);
    return null;
}
